import { getLabelMessage } from '@gef-ui/localization/messages';
import PaperPlane from '@gef-ui/material-icons/PaperPlane';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CopyButton from '../CopyButton';
const Plane = styled(PaperPlane)(({ theme })=>({
        width: 20,
        height: 20,
        fill: theme.palette.common.white
    }));
const StyledPlaneButton = styled(Button, {
    shouldForwardProp: (prop)=>prop !== 'fullSize'
})(({ theme })=>({
        '&&': {
            color: 'white'
        },
        [theme.breakpoints.down('md')]: {
            width: '100%'
        },
        variants: [
            {
                props: ({ fullSize })=>fullSize,
                style: {
                    [theme.breakpoints.up('md')]: {
                        margin: theme.spacing(0, 'auto', 0, 0)
                    }
                }
            }
        ]
    }));
const ReportButton = ({ withSendOption, isSent, onSend, fe, be, error, timestamp, fullSize, errors, isSending })=>{
    return withSendOption ? /*#__PURE__*/ React.createElement(StyledPlaneButton, {
        startIcon: /*#__PURE__*/ React.createElement(Plane, null),
        variant: "contained",
        id: "send-error-button",
        onClick: onSend,
        disabled: isSent,
        fullSize: fullSize,
        loading: isSending
    }, getLabelMessage('errors:sendError')) : /*#__PURE__*/ React.createElement(CopyButton, {
        fe: fe,
        be: be,
        error: error,
        timestamp: timestamp,
        fullSize: fullSize,
        errors: errors
    }, getLabelMessage('errors:copyError'));
};
ReportButton.propTypes = {
    be: PropTypes.array,
    error: PropTypes.object,
    errors: PropTypes.array,
    fe: PropTypes.array,
    fullSize: PropTypes.bool,
    isSending: PropTypes.bool,
    isSent: PropTypes.bool,
    onSend: PropTypes.func,
    timestamp: PropTypes.string,
    withSendOption: PropTypes.bool
};
export default ReportButton;
